<div class="float-hold" (click)="showCreateReservation = true">
    <span class="hide-mobile"><i style="color:white !important" class="fas fa-globe-europe fa-2x"></i></span>
    <div class="bubble scale-in-right " [ngClass]="{'hidden': hideInformation}" (click)="hideInformation = true">{{'Mobile Office today?' | translate}}</div>
</div>


<app-create-reservation class="reservationModal" [isMobileOffice]="true" [username]="username" [bookedSlotsForActiveDay]="bookedSlotsForActiveDay" [activeLocation]="activeLocation" *ngIf="showCreateReservation" [activeDate]="activeDate" (onClose)="onCreateReservationClose($event)"></app-create-reservation>

<div *ngIf="showCreateReservation" class="backdrop"></div>